export enum BookStatus {
  expired = 'expired',
  deleted = 'deleted',
  notVisited = 'not_visited',
  visited = 'visited',
  requested = 'requested',
  rejected = 'rejected',
}
